<template>
  <v-dialog persistent v-model="dialog" max-width="40%">
    <template v-slot:activator="{ on, attrs }">
      <div class="d-flex flex-column">
        <v-btn
          v-on="on"
          v-bind="attrs"
          color="primary"
          class="text-capitalize align-self-center"
          >Download Past Papers
          <v-icon class="mx-2">download_for_offline</v-icon></v-btn
        >
      </div>
    </template>
    <v-card class="mx-auto">
      <v-card-title>
        Download Past Papers
        <v-spacer />
        <v-btn color="red" text icon @click="dialog = !dialog"
          ><v-icon>close</v-icon></v-btn
        >
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            md="6"
            sm="12"
            v-for="(item, i) in pastPapers"
            :key="i"
          >
            <v-card :color="item.color" @click="downloadLink(item.link)" flat>
              <v-card-text>
                <div class="d-flex flex-column">
                  <v-btn
                    large
                    icon
                    :color="item.btncolor"
                    class="align-self-center"
                    @click="downloadLink(item.link)"
                  >
                    <v-icon>file_download</v-icon>
                  </v-btn>
                  <div class="align-self-center">{{ item.name }}</div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import FileMixin from "../../../mixin/FileMixin";
export default {
  name: "PastPapers",
  mixins: [FileMixin],
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    pastPapers() {
      return [
        {
          name: "APS-K",
          color: "teal lighten-4",
          btncolor: "teal darken-4",
          link: `${process.env.VUE_APP_TEMP_URL}/storage/pastpapers/APS-pastpapers.rar`,
        },
        {
          name: "CPSP-K",
          color: "green lighten-4",
          btncolor: "green darken-4",
          link: `${process.env.VUE_APP_TEMP_URL}/storage/pastpapers/CPSPK-pastpapers.rar`,
        },
      ];
    },
  },
};
</script>
